import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CopyableText from '../../../shared/components/CopyableText';
const InformationItem = ({ label, detail, render, }) => {
    return (_jsxs("div", { className: "flex justify-between text-xs py-3", children: [_jsx("span", { className: "text-default", children: label }), _jsx("span", { className: "text-gray-500", children: render ? render() : _jsx(CopyableText, { text: String(detail || '') }) })] }));
};
export default InformationItem;
